StepHandler = App.loadClass 'grower::handlers/placement/StepHandler'

class exports.DropdownsHandler extends StepHandler

    inputSel: 'select'


    getFieldAspect: (fieldID, aspectID) ->
        yArray = @taffyObjects.axes(name: 'Y').first().array

        if yArray is 'fields'
            selectedOption = @getInputEl(field: fieldID, aspect: aspectID).find('option:selected')
        else if yArray is 'y_aspects'
            selectedOption = @getInputEl(aspect: aspectID).find('option:selected')

        value = selectedOption.attr('data-value')
        option = selectedOption.attr('data-option')
        optionValue = if value? and value isnt '' then parseInt value else null
        optionID = if option? and option isnt '' then parseInt option else null

        zArray = @taffyObjects.axes(name: 'Z').first().array
        optionName = @taffyObjects[zArray](id: optionID or optionValue).first().display_name

        retval =
            value: optionValue
            options_id: optionID
            option_name: optionName

        return retval


    setFieldAspect: (fieldAspect) ->
        yArray = @taffyObjects.axes(name: 'Y').first().array

        # if fieldAspect.options_id
        if yArray is 'fields'
            input = @getInputEl
                field: fieldAspect.fields_id
                aspect: fieldAspect.aspects_id

        else if yArray is 'y_aspects'
            input = @getInputEl
                aspect: fieldAspect.aspects_id

        input.val(fieldAspect.value ? fieldAspect.options_id)
